import {POP,POPT} from '../content/economy';
import {WENDE_COST,snapPub} from './zeitgeist';
import {funding,adEffect,receptivity} from './ads';
import {buildDuel,duelEvalExtra} from './duel';
import {AX,AXN} from '../content/axes';
import {ISSUES} from '../content/issues';
import {PARTIES} from '../content/parties';
import {fatigue} from '../content/settings';
import {ISS} from '../content/states';
import {debtLimit} from './budget';
import {electionResult,isWon,lawsLeg} from './election';
import {poll,stateMood} from './govern';
import {ISS2IND,indDelta} from './indicators';
import {lobbyBonus} from './lobbies';
import {progBonus,pub} from './opinion';
import {rnd} from './rng';
import {PA} from './rules';
import {S,log} from './state';
import {clamp,dateYear} from './util';
import {axes} from './axes';
import {issuesNow} from './axes';




export const swing=(id:string)=>clamp(1-Math.abs(stateMood(id)-48)/22,.2,1);
export function tourEff(st?:any){let s=0;for(const id in st)s+=POP[id]/POPT*swing(id)*[0,1,1.6,1.95][st[id]];return s*2.4}
export const stopsUsed=():number=>Object.values(S.camp!.stops).reduce((a,b)=>a+b,0);
export const lawOn=(id:string,leg:number)=>S.laws.some((L)=>L.iss===id&&['kraft','done'].includes(L.stage)&&(L.leg??0)===leg);
export function themeOptions(first?:any){
  const list=first?issuesNow().filter((i:any)=>i.at===0).map((i:any)=>({id:i.id,n:i.n,sev:i.sev})):issuesNow().filter((i:any)=>S.issues[i.id].on).map((i:any)=>({id:i.id,n:i.n,sev:S.issues[i.id].sev}));
  list.sort((a:any,b:any)=>b.sev-a.sev);
  const ax=axes().filter((a:any)=>Math.abs(S.you[a])>=1).sort((a:any,b:any)=>Math.abs(S.you[b])-Math.abs(S.you[a])).slice(0,4).map((a:any)=>({id:'ax:'+a,n:AXN[a],ax:a}));
  return[...list.slice(0,5),{id:'wirt',n:'Wirtschaft und Arbeitsplätze'},...ax];
}
export function themeVal(id?:any){
  const c=S.camp!;
  if(id.startsWith('ax:')){const a=id.slice(3),y=S.you[a],fit=1-Math.abs(y-pub(a))/2;return clamp((fit-.35)*2.24*Math.abs(y)/2,-1.5,1.3)}
  if(id==='wirt')return c.first?.5:clamp((S.gr-.6)*1.2-(S.al-6.2)*.8+(S.saldo>debtLimit()?.3:-.3),-1.5,1.5);
  const I=ISS[id],o=c.opts.find((x:any)=>x.id===id),sev=o.sev,sal=Object.values<any>(I.imp).reduce((a,b)=>a+b,0);
  const v=c.first?(sev-45)/20+.3:(lawOn(id,S.leg)?.9:-.4)+(55-sev)/25+(ISS2IND[id]?clamp(indDelta(ISS2IND[id])*8,-.6,.6):0);
  return clamp(v*(.6+sal*.25),-1.8,1.8);
}
export function evalPromises(){
  let eff=0;const res:any=[];
  S.promises.filter((p:any)=>p.leg===S.leg).forEach((p:any)=>{
    if(p.state==='open')p.state=p.k==='iss'?(lawOn(p.iss,S.leg)?'kept':'broken'):'kept';
    eff+=p.state==='kept'?.6:-1.2;res.push(p)});
  return{eff,res};
}
export function duelQuestions(c?:any){
  return buildDuel({first:!!c.first,gov:!c.first,opp:PA(c.opp),coalition:S.partners.length>0});
}
export function duelEffect(o?:any){
  const c=S.camp!,R=rnd();
  switch(o.k){
   case 'issue':if(c.first)return[.9,'Die Kritik an der Regierung trifft einen Nerv.'];return lawOn(o.iss,S.leg)?[1.2,'Die Bilanz überzeugt. Ihr könnt Ergebnisse vorweisen.']:[-.8,'Das wirkt hohl. Eure Regierung hat dazu nichts beschlossen.'];
   case 'record':return lawOn(o.iss,S.leg)?[1.2,'Die Bilanz überzeugt. Ihr könnt Ergebnisse vorweisen.']:[-.8,'Das wirkt hohl. Eure Regierung hat dazu nichts beschlossen.'];
   case 'attack':return[.9,'Die Kritik an der Regierung trifft einen Nerv.'];
   case 'promise':if(!c.promise.some((p:any)=>p.iss===o.iss))c.promise.push({k:'iss',iss:o.iss,t:`${ISS[o.iss].n} mit einem Gesetz angehen`});return[1.1,'Das Versprechen kommt gut an. Ihr werdet daran gemessen.'];
   case 'risky':return R<.5?[1.6,'Der Angriff sitzt. Euer Gegenüber wirkt verunsichert.']:[-1,'Der Angriff geht nach hinten los und wirkt unsouverän.'];
   case 'tax':if(!c.promise.some((p:any)=>p.k==='tax'))c.promise.push({k:'tax',t:'Keine Steuererhöhungen'});return[1,'Das hören die Zuschauer gern. Ihr legt euch damit fest.'];
   case 'honest':return S.saldo<debtLimit()+3?[.6,'Ehrlichkeit wird anerkannt, die Lage ist ernst.']:[-.3,'Unnötig düster, die Haushaltslage gibt das nicht her.'];
   case 'invest':return S.you.haushalt>=1?[.8,'Glaubwürdig, das passt zu eurem Programm.']:[-.2,'Das nimmt euch niemand ab, euer Programm sagt anderes.'];
   case 'open':return[.3,'Solide, aber wenig mitreißend.'];
   case 'clear':return R<.6?[.9,'Die klare Ansage verschafft euch Profil.']:[-.4,'Die Festlegung verprellt Wechselwähler.'];
   case 'exclude':return[.6,'Die klare Abgrenzung wird von vielen begrüßt.'];
   case 'continue':return S.partners.length?(S.coal>=55?[.9,'Die Koalition gilt als stabil. Das überzeugt.']:S.coal>=35?[.2,'Nur mäßig glaubwürdig.']:[-.8,'Nach all dem Streit glaubt das kaum jemand.']):[.2,'Eine ehrliche, aber wenig begeisternde Antwort.'];
   case 'blame':return R<.4?[.7,'Die Spitze sitzt.']:[-1,'Das wirkt kleinlich. Selbst eigene Anhänger sind irritiert.'];
   case 'admit':return[.6,'Die Selbstkritik wirkt glaubwürdig.'];
   case 'reject':return R<.5?[.8,'Souverän pariert.']:[-.7,'Das wirkt dünnhäutig.'];
   case 'humor':return R<.6?[1.2,'Das Studio lacht. Ein Punkt für euch.']:[-.6,'Der Witz zündet nicht.'];
  }
  {const x=duelEvalExtra(o,S.you,!c.first,R);if(x)return x}
  return[0,''];
}
export function startCampaign(first?:any){
  if(!S.mood||!Object.keys(S.mood).length)S.mood={rent:46,fam:45,arb:44,unt:47,jung:45};
  const others=Object.keys(PARTIES).filter((k:any)=>!first&&S.res?S.res.seats[k]:true);
  const opp=first?'BU':others.sort((a:any,b:any)=>S.res.share[b]-S.res.share[a])[0];
  const c:any={first,step:'themen',themes:[],stops:{},opp,ans:[],promise:[],opts:themeOptions(first)};
  if(!first){const pe=evalPromises();c.promEff=pe.eff;c.promRes=pe.res.map((p:any)=>({t:p.t,state:p.state}))}
  c.fund=funding({share:first?15:poll(),pos:S.you,first:!!first,arbg:S.lob?.arbg,soz:S.lob?.soz,gew:S.lob?.gew,lastShare:first?null:S.elec});c.ads={};
  S.camp=c;c.q=duelQuestions(c);S.phase='campaign';S.editing=null;S.bview=false;
  if(!first)log(`Der Wahlkampf beginnt.`);
}
export function campBonus(){const c=S.camp!;return{th:c.themes.reduce((s:number,id:string)=>s+themeVal(id),0)*.55,prog:progBonus(),tour:tourEff(c.stops),duel:clamp(c.ans.reduce((s:any,a:any)=>s+a.v,0),-3,3)*.6,lob:lobbyBonus(),base:-1.2,wende:-WENDE_COST*(S.wende||0),ads:adEffect(c.ads||{},receptivity(c.themes,S.mood,!c.first),!!c.first).tot}}
export function finishCampaign(){
  const c=S.camp!,b=campBonus(),prom=c.first?0:(c.promEff||0),tot=b.th+b.tour+b.duel+b.base+b.prog+b.lob+b.wende+b.ads+prom;
  for(const id in c.stops)S.stOff[id]=clamp((S.stOff[id]||0)+c.stops[id]*.6,-8,8);
  if(c.first){
    let x=clamp(29.5+rnd()*3+tot,25,40);S.partners=[];let r=electionResult(x);
    for(let k=0;k<8&&!isWon(r);k++){x+=1;r=electionResult(x)}
    S.res=r;S.elec=r.share.YOU;S.elYear=2029;S.phase='night';
  }else{
    S.final=clamp(poll()-S.leg*fatigue()-(S.early?2:0)+(rnd()*3-1.5)+tot,4,60);
    S.res2=electionResult(S.final);S.won=isWon(S.res2);S.elYear=dateYear(S.m);S.end='election';S.phase='end';
    if(S.early){const cc=S.career[S.career.length-1];if(cc)cc.s1=S.final}
    else S.career.push({a:S.legYear,b:dateYear(S.m),s0:S.elec,s1:S.final,laws:lawsLeg(),how:'election'});
  }
  c.promise.forEach((p:any)=>S.promises.push({...p,leg:c.first?0:S.leg+1,state:'open'}));
  S.lastCamp={...b,prom,tot,first:c.first};S.camp=null;S.wende=0;snapPub(pub);
}

